export const config = {
    screens: {
      Home: {
        path: 'home',
      },
      Inscription: {
        path: 'inscription',
      },
      Login: {
        path: 'login',
      },
      MonEspace: {
        path: 'mon_espace',
      },
      MonProfil: {
        path: 'mon_profil',
      },
      ChatBot: {
        path: 'ChatBot',
      },
      DemanderDevis: {
        path: 'demander_devis',
      },
      MesContrats: {
        path: 'mes_contrats',
      },
      DetailContrat: {
        path: 'detail_contrat',
      },
      Notification: {
        path: 'notification',
      },
      DetailNotification: {
        path: 'detail_notification',
      },
      DetailSinistre: {
        path: 'detail_sinistre',
      },
      MesSinistres: {
        path: 'mes_sinistres',
      },
      DeclarerSinistre: {
        path: 'Declarer_sinistre',
      },
      FamilleSinistre: {
        path: 'famille_sinistre',
      },
      HabitationSinistre: {
        path: 'habitation_famille_sinistre',
      },
      AccidentVoyageSinistre: {
        path: 'accident_voyage_sinistre',
      },
      DemanderAvenant: {
        path: 'demander_avenant',
      },
    },
  };

export const linking = {
    prefixes: ['aro://app'],
    config,
};
